<nav [ngClass]="{'sidebar second-sidebar' : true, 'hide-sidebar' : mode == 'filtres'}">
    <ul class="list-unstyled components"
        [stepContent]="filtersStepContent"
        joyrideStep="filtersStep">
        <li>
            <a [ngClass]="{'active': currentTab == 'city'}"
               (click)="currentTab = 'city';mode = 'filtres'">
                <b>
                    <i class="icon search_zone"></i>
                    Secteur de recherche
                </b>
                <i class="fa fa-chevron-right float-right d-lg-none text-primary"></i>
                <p class="text-primary">
                    <span *ngFor="let city of cities | slice:0:3; index as icity">
                        {{ city.name }}
                        <ng-container *ngIf="icity < (cities | slice:0:3).length - 1">, </ng-container>
                    </span>
                    <span *ngIf="cities.length > 3"> + {{ cities.length - 3 }} autres villes</span>
                    <span
                        *ngIf="searchForm.get('search_city_params_id').value != '' && searchForm.get('search_city_params_id').value != '0'">
                        <ng-container *ngFor="let s of userSearchsCity">
                            <ng-container *ngIf="s.id == searchForm.get('search_city_params_id').value">
                                {{ s.title }}
                            </ng-container>
                        </ng-container>
                    </span>
                </p>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'price'}" (click)="currentTab = 'price';mode = 'filtres'">
                <b><i class="icon search_budget"></i> Budget</b>
                <i class="fa fa-chevron-right float-right d-lg-none text-primary"></i>
                <p [hidden]="filterShow('price') != 'all'">
                    Entre <span class="text-primary">{{ searchForm.get('price_min').value | number }} €</span> et
                    <span class="text-primary">{{ searchForm.get('price_max').value | number }} €</span>
                </p>
                <p [hidden]="filterShow('price') != 'max'">
                    Moins de <span class="text-primary">{{ searchForm.get('price_max').value | number }} €</span>
                </p>
                <p [hidden]="filterShow('price') != 'min'">
                    <span class="text-primary">{{ searchForm.get('price_min').value | number }} €</span> et plus
                </p>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'type'}" (click)="currentTab = 'type';mode = 'filtres'">
                <b><i class="icon search_type"></i> Type de bien et vente</b>
                <i class="fa fa-chevron-right float-right d-lg-none text-primary"></i>
                <p>
                    <span class="text-capitalize text-primary" *ngFor="let t of types; index as itypes">
                        <ng-container
                            *ngIf="t != 'commerce-fonddecommerce' && t != 'fondsdecommerce'">{{ t }}</ng-container>
                        <ng-container *ngIf="t == 'fondsdecommerce'"> Fond de commerce</ng-container>
                        <ng-container *ngIf="itypes < types.length - 1">, </ng-container>
                    </span>
                </p>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'square'}" (click)="currentTab = 'square';mode = 'filtres'">
                <b><i class="icon search_square"></i> Surface et pièces</b>
                <i class="fa fa-chevron-right float-right d-lg-none text-primary"></i>

                <p *ngIf="searchForm.get('surface') && filterShow(searchForm.get('surface').value) == 'all'">
                    Entre <span class="text-primary">{{ searchForm.get('surface').value[0] | number }}m²</span> et
                    <span class="text-primary">{{ searchForm.get('surface').value[1] | number }}m²</span>
                </p>
                <p *ngIf="searchForm.get('surface') && filterShow(searchForm.get('surface').value) == 'max'">
                    Moins de <span class="text-primary">{{ searchForm.get('surface').value[1] | number }}m²</span>
                </p>
                <p *ngIf="searchForm.get('surface') && filterShow(searchForm.get('surface').value) == 'min'">
                    <span class="text-primary">{{ searchForm.get('surface').value[0] | number }}m²</span> et plus
                </p>
            </a>
        </li>
        <li
            [stepContent]="filtersTabsContent"
            joyrideStep="filtersTabsStep"
            (prev)="currentTab = 'city'"
            (next)="currentTab = 'invest'">
            <a [ngClass]="{'active': currentTab == 'invest'}" (click)="currentTab = 'invest';mode = 'filtres'">
                <b><i class="icon invest"></i> Investissement</b>
                <i class="fa fa-chevron-right float-right d-lg-none text-primary"></i>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'advance'}" (click)="currentTab = 'advance';mode = 'filtres'">
                <b><i class="icon search_advance"></i> Critères avancés</b>
                <i class="fa fa-chevron-right float-right d-lg-none text-primary"></i>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'text'}" (click)="currentTab = 'text';mode = 'filtres'">
                <b><i class="icon search_keyword"></i> Mots clés</b>
                <i class="fa fa-chevron-right float-right d-lg-none text-primary"></i>
            </a>
        </li>
    </ul>

    <div class="container-fluid mt-4 d-lg-none">
        <div class="row mb-4">
            <div class="offset-md-3 col-md-3 col-4">
                <button class="btn btn-lg btn-outline d-block" type="submit" (click)="cancel()">
                    Annuler
                </button>
            </div>
            <div class="col-md-3 col-8">
                <button class="btn btn-lg d-block" (click)="search()"
                        [stepContent]="filtersValidateContent"
                        (prev)="currentTab = 'advance'"
                        joyrideStep="filtersValidateStep">
                    Valider
                </button>
            </div>
        </div>
    </div>
</nav>

<div id="content-second-sidebar">

    <div class="container-fluid main-card">
        <div class="row h1_row">
            <div class="col-sm-8 col-11">
                <h1>
                    {{ (this.currentSearch != undefined && this.currentSearch.title !== undefined && this.currentSearch.title !== '' ? 'Votre recherche ' + this.currentSearch.title : 'Nouvelle recherche') }}
                    <span>Trouvez les annonces rentables de votre secteur</span>
                </h1>
            </div>
            <div class="col-sm-4 col-1">
                <p class="btn btn-outline float-right  mobile-icon mt-4" (click)="openTuto()">
                    <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : Moteur de recherche</span>
                </p>
            </div>
        </div>
        <div [ngClass]="{'hide-content-sidebar' : mode == 'sidebar'}" id="searchForm">
            <a class="return-btn d-lg-none text-primary" (click)="mode = 'sidebar'">
                <i class="fa fa-chevron-left"></i>
                Filtres
            </a>
            <form [formGroup]="searchForm" (ngSubmit)="search()">
                <div [hidden]="currentTab != 'city'" class="card_tab">

                    <div class="row">
                        <div class="col-12 tabs">
                            <div class="tab {{currentTabLoc == 'city' ? 'active' : ''}} ps-5 pe-5"
                                 (click)="toogleCurrentTabLoc('city')">
                                SECTEUR SIMPLE
                            </div>
                            <div class="tab {{currentTabLoc == 'city_perso' ? 'active' : ''}} ps-5 pe-5"
                                 (click)="toogleCurrentTabLoc('city_perso')"
                                 [stepContent]="filtersCitySaveStepContent"
                                 joyrideStep="filtersCitySaveStep">
                                SECTEUR AVANCÉ
                            </div>
                        </div>
                        <div *ngIf="currentTabLoc == 'city'" class="col-12 col-md-6"
                             [stepContent]="filtersCityContent"
                             joyrideStep="filtersCityStep">
                            <mat-form-field>
                                <mat-label>Ajout d’une ville, département ou région</mat-label>
                                <input type="text" class="text" matInput formControlName="cityControl"
                                       [matAutocomplete]="autoZipcode">
                                <span matPrefix>
                                    <img class="me-2" src="assets/icons/city.svg" alt="" />
                                </span>
                                <mat-autocomplete (optionSelected)='addCity($event.option.value)'
                                                  [displayWith]="commonService.cityLabel" autoActiveFirstOption
                                                  #autoZipcode="matAutocomplete">
                                    <mat-option *ngFor="let city of zipCode" [value]="city">
                                        {{ city.name }}
                                        ({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }}
                                        )
                                    </mat-option>
                                </mat-autocomplete>
                                <span matSuffix>
                                    <div class="citySpinner">
                                        <mat-spinner diameter="20"></mat-spinner>
                                    </div>
                                </span>
                            </mat-form-field>
                        </div>
                        <div *ngIf="currentTabLoc == 'city'" class="col-12">
                            <div class="city-wrap">
                                <p *ngFor="let r of region" class="region">
                                    <b class="fs-large me-2"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ r }}</b>
                                    <span class="text-grey">(région)</span>
                                    <i class="fa fa-remove" (click)="removeRegion(r)"></i>
                                </p>
                                <p *ngFor="let d of departement" class="departement">
                                    <b class="fs-large me-2"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ d }}</b>
                                    <span class="text-grey">(département)</span><br/>
                                    <i class="fa fa-remove" (click)="removeDepartement(d)"></i>
                                </p>
                                <p *ngFor="let city of cities">
                                    <b class="fs-large me-2"><i class="fa fa-map-marker"
                                                                aria-hidden="true"></i> {{ city.name }}</b>
                                    <span
                                        class="text-grey">({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }}
                                        )</span>
                                    <i class="fa fa-remove" (click)="removeCity(city)"></i>
                                    <ngx-slider [options]="optionsDistance" (userChangeEnd)="loadCities()"
                                                [(value)]="city.km"></ngx-slider>
                                </p>
                            </div>
                        </div>
                        <div *ngIf="currentTabLoc == 'city'" class="col-12 text-center text-grey mt-4">
                            <ng-container class="col-12 text-center text-grey mb-2"
                                          *ngIf="citiesSearch && citiesSearch.length < 2000">
                                Votre recherche comporte {{ citiesSearch.length }} villes
                            </ng-container>
                            <ng-container class="col-12 text-center text-grey mb-2"
                                          *ngIf="citiesSearch && citiesSearch.length >= 2000">
                                Votre recherche comporte + de 2000 villes
                            </ng-container>
                        </div>

                        <div *ngIf="currentTabLoc == 'city_perso'" class="col-12 col-md-6">
                            <mat-form-field [stepContent]="filtersCitySaveListStepContent"
                                            joyrideStep="filtersCitySaveListStep">
                                <mat-label>Sélectionner un secteur enregistré</mat-label>
                                <mat-select disableOptionCentering formControlName="search_city_params_id"
                                            [disabled]="userSearchsCity.length == 0 || !authenticationService.isAllowed('essentiel')"
                                            class="select-search" placeholder="Mes villes enregistrées">
                                    <mat-option [value]="0">Sélectionner un secteur enregistré</mat-option>
                                    <mat-option *ngFor="let s of userSearchsCity"
                                                [value]="s.id">{{ s.title }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="currentTabLoc == 'city_perso'" class="col-12">
                            <div class="row">
                                <div class="col-12 col-md-6 mt-5">
                                    <p>Vous voulez créer un secteur de recherche avec des critères avancés ?
                                        <a class="link" (click)="createSecteur()">
                                            Cliquez ici
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="currentTabLoc == 'city_perso'" class="col-12 col-md-9">
                            <div class="card">
                                <b class="mb-2">Qu’est ce qu’un secteur de recherche personnalisé ?</b>
                                <p>
                                    Vous pouvez créer et enregistrer une liste de villes qui correspondent à vos
                                    critères, en utilisant des filtres sociodémographique et immobilier.
                                    Vous pourrez ensuite chercher des annonces immobilières dans cette liste de ville.
                                </p>
                                <p>
                                    Exemple : Vous habitez à Bordeaux et vous cherchez dans un rayon de 100 km autour de
                                    la ville.
                                    Vous pourrez sélectionner les villes avec plus de 10.000 habitants, un prix au m²
                                    inférieur à 2.000€/m², un rendement moyen de plus de 6%, une démographie en hausse,
                                    des prix de l’immobilier en hausse...
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'price'" class="card_tab">
                    <div class="row">
                        <h2>
                            Quel est votre budget
                        </h2>

                        <div class="col-12">
                            <div class="row">
                                <div class="col-6 col-md-3 pe-0">
                                    <mat-form-field>
                                        <mat-label>Min</mat-label>
                                        <input type="number" step="1000" matInput formControlName="price_min">
                                        <span matSuffix> €</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-6  col-md-3">
                                    <mat-form-field>
                                        <mat-label>Max</mat-label>
                                        <input type="number" step="1000" matInput formControlName="price_max">
                                        <span matSuffix> €</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="card mt-5 p-5 text-center simul">
                                <h3 class="mt-0">Votre mensualité (sans apport) sera entre :</h3>
                                <div class="value">
                                    {{ monthly_min }}<span class="unit"> €/par mois</span>
                                    <span class="unit ms-5 me-5">et</span>
                                    {{ monthly_max }}<span class="unit"> €/par mois</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'type'" class="card_tab">
                    <div class="row">
                        <h2>
                            Typologie du bien
                        </h2>
                        <div class="col-12">
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('maison')}"
                                       (click)="toogleType('maison')">
                                        <i class="icon icon-maison"></i>
                                        Maison
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('appartement')}"
                                       (click)="toogleType('appartement')">
                                        <i class="icon icon-appartement"></i>
                                        Appartement
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('parking')}"
                                       (click)="toogleType('parking')">
                                        <i class="icon icon-garage"></i>
                                        Garage
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('immeuble')}"
                                       (click)="toogleType('immeuble')">
                                        <i class="icon icon-immeuble"></i>
                                        Immeuble
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('terrain')}"
                                       (click)="toogleType('terrain')">
                                        <i class="icon icon-terrain"></i>
                                        Terrain
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('commerce-fonddecommerce'), 'lock': !authenticationService.isAllowed('expert')}"
                                       (click)="toogleType('commerce-fonddecommerce')">
                                        <i class="icon icon-commerce"></i>
                                        <i class="icon icon-lock"
                                           *ngIf="!authenticationService.isAllowed('expert')"></i>
                                        Commerce<br/>
                                        <span
                                            *ngIf="!authenticationService.isAllowed('expert')">(Plan expert)</span>
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('autre')}"
                                       (click)="toogleType('autre')">
                                        <i class="icon icon-autre"></i>
                                        Autre
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <h2 *ngIf="types.includes('commerce-fonddecommerce')">
                            Commerces et locaux commerciaux
                        </h2>
                        <div class="col-12"
                             *ngIf="types.includes('commerce-fonddecommerce')">
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('commerce')}"
                                       (click)="toogleType('commerce')">
                                        <i class="icon icon-commerce"></i>
                                        Commerce
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': types && types.includes('fondsdecommerce')}"
                                       (click)="toogleType('fondsdecommerce')">
                                        <i class="icon icon-fondcommerce"></i>
                                        Fond de commerce
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <h2>
                            Type de vente
                        </h2>
                        <div class="col-12">
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': categories && categories.includes('ventes')}"
                                       (click)="toogleCategory('ventes')">
                                        <i class="icon icon-maison"></i>
                                        Vente immobilière
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': categories && categories.includes('viager')}"
                                       (click)="toogleCategory('viager')">
                                        <i class="icon icon-get-money"></i>
                                        Viager
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': categories && categories.includes('enchere')}"
                                       (click)="toogleCategory('enchere')">
                                        <i class="icon icon-enchere"></i>
                                        Enchère
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': categories && categories.includes('residence')}"
                                       (click)="toogleCategory('residence')">
                                        <i class="icon icon-residence"></i>
                                        Residence gérée<br/>
                                        Étudiante, EHPAD ...
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="col-lg-6 col-12">
                            <h2>
                                Type de bien
                            </h2>
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': estate_sale && estate_sale.includes('neuf')}"
                                       (click)="toogleEstateSale('neuf')">
                                        <i class="icon icon-neuf"></i>
                                        Neuf
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': estate_sale && estate_sale.includes('ancien')}"
                                       (click)="toogleEstateSale('ancien')">
                                        <i class="icon icon-ancien"></i>
                                        Ancien
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-6 col-12">
                            <h2>
                                Type de vendeur
                            </h2>
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': owner_type && owner_type.includes('pro')}"
                                       (click)="toogleOwnerType('pro')">
                                        <i class="icon icon-pro"></i>
                                        Professionnel
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': owner_type && owner_type.includes('private')}"
                                       (click)="toogleOwnerType('private')">
                                        <i class="icon icon-part"></i>
                                        Particulier
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'square'" class="card_tab">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <h2>Surface du bien</h2>
                            <div class="row pe-4" *ngIf="currentSearch">
                                <div class="col-6 pe-0">
                                    <mat-form-field>
                                        <mat-label>Min</mat-label>
                                        <input matInput type="number" step="10"
                                               [(ngModel)]="currentSearch.search_ad_params.surface[0]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-6 pe-5">
                                    <mat-form-field>
                                        <mat-label>Max</mat-label>
                                        <input matInput type="number" step="10"
                                               [(ngModel)]="currentSearch.search_ad_params.surface[1]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>Surface du terrain</h2>
                            <div class="row" *ngIf="currentSearch">
                                <div class="col-6 pe-0">
                                    <mat-form-field>
                                        <mat-label>Min</mat-label>
                                        <input matInput type="number" step="100"
                                               [(ngModel)]="currentSearch.search_ad_params.surface_land[0]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-form-field>
                                        <mat-label>Max</mat-label>
                                        <input matInput type="number" step="100"
                                               [(ngModel)]="currentSearch.search_ad_params.surface_land[1]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <div class="row pe-4">
                                <div class="col-12">
                                    <h2>Nombre de pièces</h2>
                                    <ul class="nav nav-tabs search-small-type">
                                        <li class="nav-item col-2" matTooltipClass="tooltip-button"
                                            matTooltip="Non communiqué">
                                            <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(0)}"
                                               (click)="toogleRooms(0)">
                                                NC
                                                <span class="check"><i class="fa fa-check"></i></span>
                                            </a>
                                        </li>
                                        <li class="nav-item col-2">
                                            <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(1)}"
                                               (click)="toogleRooms(1)">
                                                1
                                                <span class="check"><i class="fa fa-check"></i></span>
                                            </a>
                                        </li>
                                        <li class="nav-item col-2">
                                            <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(2)}"
                                               (click)="toogleRooms(2)">
                                                2
                                                <span class="check"><i class="fa fa-check"></i></span>
                                            </a>
                                        </li>
                                        <li class="nav-item col-2">
                                            <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(3)}"
                                               (click)="toogleRooms(3)">
                                                3
                                                <span class="check"><i class="fa fa-check"></i></span>
                                            </a>
                                        </li>
                                        <li class="nav-item col-2">
                                            <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(4)}"
                                               (click)="toogleRooms(4)">
                                                4
                                                <span class="check"><i class="fa fa-check"></i></span>
                                            </a>
                                        </li>
                                        <li class="nav-item col-2">
                                            <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(5)}"
                                               (click)="toogleRooms(5)">
                                                5 et +
                                                <span class="check"><i class="fa fa-check"></i></span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>Étage</h2>
                            <ul class="nav nav-tabs search-small-type search-floor">
                                <li class="nav-item col-2" matTooltipClass="tooltip-button"
                                    matTooltip="Non communiqué">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('nc')}"
                                       (click)="toogleFloor('nc')">
                                        NC
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('rdc')}"
                                       (click)="toogleFloor('rdc')">
                                        RDC
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('1')}"
                                       (click)="toogleFloor('1')">
                                        1er
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('2plus')}"
                                       (click)="toogleFloor('2plus')">
                                        2 et +
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('_Last')}"
                                       (click)="toogleFloor('_Last')">
                                        Dernier
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <h2>
                            Atouts du bien
                        </h2>
                        <div class="col-12">
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4" matTooltipClass="tooltip-button"
                                    matTooltip="Jardin, balcon, terrasse">
                                    <a [ngClass]="{'nav-link': true, 'active': assets && assets.includes('outside')}"
                                       (click)="toogleAssets('outside')">
                                        <i class="icon icon-outside"></i>
                                        Éxtérieur
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4" matTooltipClass="tooltip-button"
                                    matTooltip="Parking, stationnement, garage ...">
                                    <a [ngClass]="{'nav-link': true, 'active': assets && assets.includes('parking')}"
                                       (click)="toogleAssets('parking')">
                                        <i class="icon icon-parking"></i>
                                        Parking
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': assets && assets.includes('elevator')}"
                                       (click)="toogleAssets('elevator')">
                                        <i class="icon icon-elevator"></i>
                                        Ascenseur
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'invest'" class="card_tab">
                    <div class="row">
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersSquarePriceContent"
                             joyrideStep="filtersSquarePriceStep">

                            <h2>
                                Prix au m²
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsSquarePrice.disabled"></i>
                            </h2>
                            <ngx-slider [highValue]="optionsSquarePrice.ceil" [options]="optionsSquarePrice"
                                        [value]="0" formControlName="squarePrice"></ngx-slider>
                        </div>
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersDiffContent"
                             joyrideStep="filtersDiffStep">

                            <h2>Difference prix au m²
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsDiff.disabled"></i></h2>
                            <ngx-slider [highValue]="optionsDiff.ceil" [options]="optionsDiff" [value]="-100"
                                        formControlName="squarePriceDiff"></ngx-slider>
                        </div>
                        <div class="col-12"
                             [stepContent]="filtersRendementContent"
                             joyrideStep="filtersRendementStep"
                             (prev)="currentTab = 'invest'"
                             (next)="currentTab = 'advance'">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>Rendement brut
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsRendement.disabled"></i></h2>
                                    <ngx-slider [highValue]="optionsRendement.ceil" [options]="optionsRendement"
                                                [value]="0"
                                                formControlName="rendement"></ngx-slider>
                                </div>
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Cash-flow
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsCashflow.disabled"></i>
                                    </h2>
                                    <ngx-slider [highValue]="optionsCashflow.ceil" [options]="optionsCashflow"
                                                [value]="0"
                                                formControlName="cashflow"></ngx-slider>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Baisse de prix (en %)
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceChangePercent.disabled"></i>
                                    </h2>
                                    <ngx-slider [highValue]="optionsPriceChangePercent.ceil"
                                                [options]="optionsPriceChangePercent" [value]="0"
                                                formControlName="price_change_percent"></ngx-slider>
                                </div>
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Baisse de prix (en €)
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceChangeEuro.disabled"></i>
                                    </h2>
                                    <ngx-slider [highValue]="optionsPriceChangeEuro.ceil"
                                                [options]="optionsPriceChangeEuro" [value]="0"
                                                formControlName="price_change_euro"></ngx-slider>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Charge de copropriété annuel
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsAmountCopro.disabled"></i>
                                    </h2>
                                    <ngx-slider [highValue]="optionsAmountCopro.ceil"
                                                [options]="optionsAmountCopro"
                                                [value]="0"
                                                formControlName="amount_copro"></ngx-slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'advance'" class="card_tab">
                    <div class="row">
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersDPEContent"
                             joyrideStep="filtersDPEStep"
                             (prev)="currentTab = 'invest'">
                            <h2>
                                DPE
                            </h2>
                            <ul class="nav nav-tabs search-small-type search-dpe mt-3">
                                <li class="nav-item col-2" matTooltipClass="tooltip-button"
                                    matTooltip="Non communiqué">
                                    <a [ngClass]="{'nav-link': true, 'active': dpe && dpe.includes(0)}"
                                       (click)="toogleDpe(0)">
                                        NC
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link dpe_A': true, 'active': dpe && dpe.includes(1)}"
                                       (click)="toogleDpe(1)">
                                        A
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link dpe_B': true, 'active': dpe && dpe.includes(2)}"
                                       (click)="toogleDpe(2)">
                                        B
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link dpe_C': true, 'active': dpe && dpe.includes(3)}"
                                       (click)="toogleDpe(3)">
                                        C
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link  dpe_D': true, 'active': dpe && dpe.includes(4)}"
                                       (click)="toogleDpe(4)">
                                        D
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link dpe_E': true, 'active': dpe && dpe.includes(5)}"
                                       (click)="toogleDpe(5)">
                                        E
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link dpe_F': true, 'active': dpe && dpe.includes(6)}"
                                       (click)="toogleDpe(6)">
                                        F
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link  dpe_G': true, 'active': dpe && dpe.includes(7)}"
                                       (click)="toogleDpe(7)">
                                        G
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersMonthContent"
                             joyrideStep="filtersMonthStep">
                            <h2>
                                Ancienneté de l'annonce
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsMonth.disabled"></i>
                            </h2>
                            <ngx-slider [highValue]="optionsMonth.ceil" [options]="optionsMonth" [value]="0"
                                        formControlName="month"></ngx-slider>
                        </div>


                        <div class="col-md-6 col-12">
                            <h2>
                                Travaux
                            </h2>
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': work && work.includes('nc')}"
                                       (click)="toogleWork('nc')">
                                        <i class="icon icon-question"></i>
                                        Inconnu
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': work && work.includes('work')}"
                                       (click)="toogleWork('work')">
                                        <i class="icon icon-work"></i>
                                        Avec travaux
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': work && work.includes('renov')}"
                                       (click)="toogleWork('renov')">
                                        <i class="icon icon-nowork"></i>
                                        Sans travaux
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>
                                Locataire en place
                            </h2>
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': rent && rent.includes(0)}"
                                       (click)="toogleRent(0)">
                                        <i class="icon icon-norent"></i>
                                        Non
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': rent && rent.includes(1)}"
                                       (click)="toogleRent(1)">
                                        <i class="icon icon-rent"></i>
                                        Oui
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>
                                Divers
                            </h2>
                            <ul class="nav nav-tabs search-type">
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': other && other.includes('exclude_copro')}"
                                       (click)="toogleOther('exclude_copro')">
                                        <i class="icon icon-copro"></i>
                                        Exclure les biens en copropriété
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': other && other.includes('exclude_local_commercial')}"
                                       (click)="toogleOther('exclude_local_commercial')">
                                        <i class="icon icon-commerce"></i>
                                        Exclure les locaux commerciaux
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4">
                                    <a [ngClass]="{'nav-link': true, 'active': other && other.includes('no_pictures')}"
                                       (click)="toogleOther('no_pictures')">
                                        <i class="icon icon-nopictures"></i>
                                        Sans photos uniquement
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-xxl-2 col-md-4" matTooltipClass="tooltip-button"
                                    matTooltip="Divorce, mutation, sucession ...">
                                    <a [ngClass]="{'nav-link': true, 'active': other && other.includes('urgent')}"
                                       (click)="toogleOther('urgent')">
                                        <i class="icon icon-urgent"></i>
                                        Vente urgente uniquement
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'text'" class="card_tab">
                    <div class="row">
                        <h2>
                            Recherche par mots clés
                        </h2>
                        <div class="col-md-6 col-12">
                            <mat-form-field>
                                <mat-label>Recherche</mat-label>
                                <input type="text" class="text" matInput formControlName="search">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-12">
                            <mat-checkbox formControlName="search_title" class="mt-3">
                                Recherche dans le titre uniquement
                            </mat-checkbox>
                        </div>
                        <div class="col-12 col-md-9">
                            <div class="card mt-5">
                                <b class="mb-2">Quelques astuces pour votre recherche :</b>
                                <!-- https://www.elastic.co/fr/blog/leviers-elasticsearch-pour-le-traitement-des-specificites-linguistiques -->
                                <ul>
                                    <li class="mb-1">Lorsque vous faites une recherche par mots clés, privilégiez le
                                        singulier avec une * à la fin : immeuble* pour recherche tous les mots qui
                                        commence par immeuble. Ainsi l'outils recherchera aussi bien immeubles et
                                        immeuble.<br/>
                                        Pour division, si vous recherchez divi* vous aurez tous les mots : diviser,
                                        division, divisable ...
                                    </li>
                                    <li class="mb-1">Si vous souhaitez faire une recherche sur plusieurs mots, il
                                        est important d'utiliser les guillemets : "terrain constructible". Si vous
                                        recherchez sans les guillemets, l'outil affichera les annonces avec
                                        "terrain" OR "constructible".
                                    </li>
                                    <li class="mb-1">Si vous souhaitez faire une recherche en excluant certain termes,
                                        vous
                                        pouvez utiliser NOT. Exemple "hotel" NOT "particulier"
                                    </li>
                                    <li class="mb-1">
                                        Si vous souhaitez faire une recherche sur les biens avec ou sans travaux,
                                        utiliser le filtre présent dans "Critères avancés".<br/>
                                        Il comporte plus de 40 cas pour avoir un filtre très optimisé.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="offset-md-3 col-md-3 col-4">
                        <button class="btn btn-lg btn-outline d-block" type="submit" (click)="cancel()">
                            Annuler
                        </button>
                    </div>
                    <div class="col-md-3 col-8">
                        <button class="btn btn-lg d-block" (click)="search()"
                                [stepContent]="filtersValidateContent"
                                (prev)="currentTab = 'advance'"
                                joyrideStep="filtersValidateStep">
                            Valider
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<ng-template #filtersStepContent>
    <div class="user_onboarding_content">
        <h2>Définissez vos critères</h2>
        <p>
            C’est ici que vous allez construire votre <b>recherche de bien rentable.</b><br/>
            <br/>
            Vous pouvez naviguer dans le menu de gauche pour définir vos <b>critères de recherche.</b><br/>
            <br/>
            Faisons le tour ensemble !
        </p>
    </div>
</ng-template>

<ng-template #filtersCityContent>
    <div class="user_onboarding_content">
        <h2>Localisation</h2>
        <p>
            Pour commencer, choisissez votre secteur de recherche.<br/>
            <br/>
            Vous pouvez renseigner une <b>ville</b>, un <b>département</b>, et même une <b>région</b>.<br/>
            <br/>
            <b>Astuce</b> : Vous pouvez définir un rayon jusqu’à <b>100 km autour d’une ville</b> !
            <br/>
        </p>
    </div>
</ng-template>

<ng-template #filtersCitySaveStepContent>
    <div class="user_onboarding_content">
        <h2>Secteur de recherche personnalisé</h2>
        <p>
            L’application LyBox dispose d’un <b>module</b> entier pour vous aider à <b>trouver les villes à
            potentiel</b>, partout en France.<br/>
            <br/>
            Ce module sera détaillé lors des <b>prochaines étapes</b> pour démarrer avec LyBox.<br/>
            <br/>
            Une fois votre secteur personnalisé créé, vous pourrez le sélectionner ici.
        </p>
    </div>
</ng-template>

<ng-template #filtersTabsContent>
    <div class="user_onboarding_content">
        <h2>Critères de recherche avancés</h2>
        <p>
            Nous allons nous intéresser aux filtres que <b>vous ne trouverez pas sur les sites immobiliers
            classiques.</b><br/>
            <br/>
            En tant qu’investisseur immobilier, une bonne utilisation de ces filtres vous permettra d’être plus
            efficaces et de <b>doubler les autres investisseurs</b> !
        </p>
    </div>
</ng-template>

<ng-template #filtersSquarePriceContent>
    <div class="user_onboarding_content">
        <h2>Prix au m² des annonces</h2>
        <p>
            Sélectionner un minimum et un maximum <b>de prix au m²</b> pour ne faire ressortir que les meilleures
            annonces.
        </p>
    </div>
</ng-template>

<ng-template #filtersRendementContent>
    <div class="user_onboarding_content">
        <h2>Rendement locatif brut</h2>
        <p>
            Filtrer sur les annonces avec un fort <b>rendement locatif</b> et générant du <b>cash-flow</b>
        </p>
    </div>
</ng-template>

<ng-template #filtersDiffContent>
    <div class="user_onboarding_content">
        <h2>Différence de prix par rapport au marché local</h2>
        <p>
            <b>Encore mieux</b> : vous pouvez choisir de ne voir que les annonces <b>sous le prix du marché</b>. Très
            utile si vous cherchez dans plusieurs villes différentes.<br/>
            <br/>
            <b>Exemple</b> : Vous cherchez dans une ville “A” ou le prix moyen est de 3.000€/m², mais aussi dans une
            ville “B” ou le prix moyen est de 2.000€/m².<br/>
            <br/>
            Vous pouvez régler le curseur sur -10% pour ne voir que les annonces qui :
        </p>
        <ul>
            <li>Sont à moins de 2.700€/m² dans la ville “A”</li>
            <li>Sont à moins de 1.800€/m² dans la ville “B”</li>
        </ul>
        <p>
            Pas mal, non?
        </p>
    </div>
</ng-template>

<ng-template #filtersDPEContent>
    <div class="user_onboarding_content">
        <h2>Diagnostic de performance énergétique</h2>
        <p>
            Le DPE est devenu un vrai enjeu pour les investisseurs depuis la <b>Loi Climat</b>.<br/>
            <br/>
            Vous pouvez par exemple filtrer sur les <b>passoires énergétiques</b> (F et G) et tenter de fortes
            négociations !
        </p>
    </div>
</ng-template>

<ng-template #filtersMonthContent>
    <div class="user_onboarding_content">
        <h2>Ancienneté de l’annonce</h2>
        <p>
            Grâce à ce filtre, vous pouvez vous concentrer sur <b>les biens en vente depuis plusieurs mois</b>.<br/>
            <br/>
            LyBox est capable de détecter les <b>annonces supprimées puis repostées</b>, et vous affiche toujours <b>la
            première date de publication</b>.<br/>
            <br/>
            L’application est aussi capable de détecter les <b>baisses de prix</b>.<br/>
            <br/>
            Mais ça, c’est pour la suite 😉
        </p>
    </div>
</ng-template>

<ng-template #filtersValidateContent>
    <div class="user_onboarding_content">
        <h2>Valider votre recherche</h2>
        <p>
            Cliquez ici pour accéder aux résultats de recherche.<br/>
            <br/>
            Vous pourrez <b>enregistrer</b> vos critères de recherche sur le prochain écran.
        </p>
    </div>
</ng-template>

<ng-template #filtersCitySaveListStepContent>
    <div class="user_onboarding_content">
        <h2>Vos secteurs de recherche</h2>
        <p>
            Retrouvez ici la liste de vos secteurs de recherche pour les utiliser dans vos recherches de biens.
        </p>
    </div>
</ng-template>
